import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetContentTypesRes, IGetContentTypesQueryParams } from "types/content"
import languageSettingsService from "api/contentService"

export interface IUseGetContentTypesParams {
  query: IGetContentTypesQueryParams,
  enabled: boolean
}

const useGetContentTypes = ({
  query,
  enabled
}: IUseGetContentTypesParams) => {
  return useQuery(["content_types", {...query}], async () => {
    try {
      const res: AxiosResponse<IGetContentTypesRes> = await languageSettingsService.getContentTypes(query)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetContentTypes